import { IOrganization } from "../../services/organization-data-service/Models";

    const getChildren = (organizations: IOrganization[] | undefined, parent: IOrganization) => {

        const children = organizations?.filter(o => o.parentID === parent.id);

        if (children) {
            parent.children = [];

            children.forEach((value: IOrganization, index: number) => {

                getChildren(organizations, value);

                parent.children?.push(value);
            });
        }
    }


    const OrganizationHierarchyUtils = {

        getTreeData: function (organizations: IOrganization[] | undefined, organizationID: number): IOrganization | undefined {

            let data = organizations?.find(o => o.id === organizationID);

            if (data) {
                getChildren(organizations, data);
            }

            return data;

        },
        getAncestors: function (organizations: IOrganization[] | undefined, organizationID: number): IOrganization[] | undefined {

            let data = organizations?.find(o => o.id === organizationID);

            if (data) {

                const ancestors: IOrganization[] = [];
        
                for (let parentID = data?.parentID; parentID;) {
                    let parent = organizations?.find(o => o.id === parentID) as IOrganization;

                    getChildren(organizations, parent);

                    ancestors.unshift(parent);
                    parentID = parent.parentID;
                }
        
                return ancestors;
            }

            return data;
        }

    };
    
    export default OrganizationHierarchyUtils;
        